module.exports = __webpack_public_path__ + "soundfont/NewDrumSamples/MP3/Hi Hat Open-3df471e2317aff91b1714f54a64d59bf.mp3";


//////////////////
// WEBPACK FOOTER
// ./soundfont/NewDrumSamples/MP3/Hi Hat Open.mp3
// module id = 55
// module chunks = 0